/*jshint esversion: 9 */
import React from "react";
// import { Fragment } from "react";
import { connect } from "react-redux";
// import { withStyles } from "@material-ui/core/styles";
import {
  doLog,
  // getMMDDYYYYTime,
  hasValue,
  // LogDebug,
  notNull,
  getSubElement,
  updateObject,
} from "../../shared/utility";

import * as actions from "../../store/actions/index";
import blankshield from "blankshield";
import Button from "@material-ui/core/Button";
// import Card from "../../components/UI/Card/Card";
// import classes from "../CrimeSubmission.css";
import Grid from "@material-ui/core/Grid";
import Form from "../../components/UI/Form/Form";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
import moment from "moment";
// import Radio from "@material-ui/core/Radio";
// import RadioGroup from "@material-ui/core/RadioGroup";
import Spinner from "../../components/UI/Spinner/Spinner";

let mappedSelectPropFields = [];

let mappedTextPropFields = ["paramStartDate", "paramEndDate"];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40
// const quote = '"';
// const singleQuote = "'";

class Report extends Form {
  state = {
    searching: false,
    editMode: true,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    keyFieldValue: null,
    //
    // formBuilt: false,
    reportRunning: false,
    currentFile: null,
    fieldArray: null,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    TIMSReportAgency: { value: "CitizenWeb" },
    personID: { value: "1" },
    paramJuris: { value: "" },
    //
    paramStartDate: {
      inputType: "datepicker",
      value: moment().format("MM/DD/YYYY"),
      label: "From Date",
      disableFuture: true,
      validation: { required: true },
    },
    paramEndDate: {
      inputType: "datepicker",
      value: moment().format("MM/DD/YYYY"),
      label: "To Date",
      disableFuture: true,
      validation: { required: true },
    },
  };

  componentDidMount() {
    if (doLog()) console.log("[Report] componentDidMount state:", this.state);
    if (doLog()) console.log("[Report] componentDidMount props:", this.props);
    let fieldArray = [];

    mappedSelectPropFields = [];
    mappedTextPropFields = ["paramStartDate", "paramEndDate"];

    this.setState({ buildingForm: true });
    // if (!this.state.formBuilt) {
    // INISECTN prevData = (INISECTN)FormDefaults.get(fileName);
    // return new FORMWIN( form, fileName, Dir, ClientController, this, prevData, MC );
    this.addControls(fieldArray);
    this.setState({ buildingForm: false, fieldArray: fieldArray });
    // }
    blankshield.patch();
  }

  componentDidUpdate() {
    if (doLog()) console.log("[Report] componentDidUpdate state:", this.state);
    if (doLog()) console.log("[Report] componentDidUpdate props:", this.props);

    if (!this.state.buildingForm) {
      if (
        this.state.reportRunning &&
        this.props.reportError === null &&
        this.props.reportResult !== null
      ) {
        this.setState({ reportRunning: false });
      }
    }
  }

  addControl = (fieldArray, node) => {
    if (doLog()) console.log("[Report] addControl node:", node);
    const id = node.getAttribute("ID");
    const label = node.getAttribute("Label");
    let type = node.getAttribute("type");
    if (type === "dropdown") {
      type = "select";
    } else if (type === "date") {
      type = "datepicker";
    }
    let defaultValue = "";
    if (hasValue(node.getAttribute("default"))) {
      defaultValue = node.getAttribute("default");
    }
    let requiredValue = null;
    if (hasValue(node.getAttribute("required"))) {
      requiredValue = node.getAttribute("required");
    }
    let listName = node.getAttribute("listTable");
    if (doLog()) console.log("[Report] addControl id:", id);
    if (doLog()) console.log("[Report] addControl type:", type);
    if (doLog()) console.log("[Report] addControl listName:", listName);
    fieldArray.push(id);
    if (hasValue(this.state[id])) {
      // Handle default fields like start and end dates
      this.setState({
        [id]: updateObject(this.state[id], {
          included: true,
        }),
      });
    } else {
      // Add new fields
      if (type === "select") {
        mappedSelectPropFields.push(id);
        if (listName === "CitizenWebAgency") {
          listName = "agencyOptions";
          if (this.props.modulePermissions.allowedAgencyCode !== "ALL") {
            defaultValue = this.props.ori;
          } else {
            defaultValue = "ALL";
          }
        } else if (listName === "CitizenWebAgencyCode") {
          listName = "agencyCodeOptions";
          if (doLog()) console.log("[Report] addControl listName now:", listName);
          if (this.props.modulePermissions.allowedAgencyCode !== "ALL") {
            defaultValue = this.props.modulePermissions.allowedAgencyCode;
            // } else {
            //   defaultValue = "ALL";
          }
        }
      } else {
        mappedTextPropFields.push(id);
      }
      this.setState({
        [id]: {
          inputType: type,
          value: defaultValue,
          label: label,
          validation: { required: requiredValue },
          included: true,
          checkedValue: "true",
          uncheckedValue: "false",
          listName: listName,
        },
      });
    }
  };

  addControls = (fieldArray) => {
    let layout = null;
    // if (doLog()) console.log("[Report] addControls reportDefinition:", this.props.reportDefinition);
    const reportElement = this.props.reportDefinition;
    layout = getSubElement(reportElement, "LAYOUT");
    if (doLog()) console.log("[Report] addControls layout:", layout);
    this.layoutControls(fieldArray, layout);
    // this.setState({ formBuilt: true });
    this.setState({
      mappedTextPropFields: mappedTextPropFields,
      mappedSelectPropFields: mappedSelectPropFields,
    });
  };

  handleSubmitButton = () => {
    if (doLog()) console.log("[Report] handleSubmitButton");
    const reportElement = this.props.reportDefinition;
    const transmitElement = getSubElement(reportElement, "TRANSMIT");
    if (doLog())
      console.log("[Report] addControls transmitElement:", transmitElement);
    const transmitStringElement = getSubElement(
      transmitElement,
      "TransmitString"
    );
    if (doLog())
      console.log(
        "[Report] addControls transmitStringElement:",
        transmitStringElement
      );
    let transmitString = transmitStringElement.childNodes[0].nodeValue;
    // if (doLog()) console.log("[Report] addControls transmitString:", transmitString);
    transmitString = transmitString.replaceAll("\n", "");
    transmitString = transmitString.replaceAll("\t", "");
    const options = transmitString.split("~");
    const optionCount = options.length;
    if (doLog()) console.log("[Report] addControls options:", options);
    for (let i = 0; i < optionCount; i++) {
      let option = options[i].trim();
      option = this.translateParamVariables(option);
      options[i] = option;
    }
    transmitString = options.join("~");
    if (doLog())
      console.log("[Report] addControls new transmitString:", transmitString);
    this.props.onRunReport(
      transmitString,
      true,
      10,
      "RunReports",
      this.props.token
    );
    this.setState({ reportRunning: true });
  };

  layoutControls = (fieldArray, group) => {
    const count = group.childElementCount;
    if (doLog()) console.log("[Report] layoutControls count:", count);
    for (let i = 0; i < count; i++) {
      const node = group.children[i];
      if (doLog()) console.log("[Report] layoutControls node:", node);
      const nodeName = node.localName;
      if (doLog()) console.log("[Report] layoutControls nodeName:", nodeName);
      if (nodeName === "F") {
        this.addControl(fieldArray, node);
      } else if (nodeName === "NL") {
        //TODO: handle next line
      } else if (nodeName === "COLUMN") {
        this.layoutControls(fieldArray, node);
      }
    }
  };

  translateParamVariables = (option) => {
    let newOption = "";
    if (doLog())
      console.log("[Report] translateParamVariables option:", option);
    //loop until there are no more ${ strings to find.
    let startPos = option.indexOf("${");
    if (startPos === -1)
      newOption = option;
    let lastPos = 0;
    let endPos = -1;
    while (startPos !== -1) {
      // if (doLog())
      //   console.log("[Report] translateParamVariables startPos at top of while:", startPos);
      // if (doLog())
      //   console.log("[Report] translateParamVariables option at top of while:", option);
      endPos = option.indexOf("}", startPos);
      // if (doLog())
      //   console.log("[Report] translateParamVariables endPos at top of while:", endPos);
      if (endPos !== -1) {
        let paramName = option.substring(startPos + 2, endPos);
        if (doLog())
          console.log("[Report] translateParamVariables paramName:" + paramName + " startPos:" + startPos + " endPos:" + endPos);
        if (hasValue(this.state[paramName])) {
          const newValue = this.state[paramName].value;
          if (doLog())
            console.log("[Report] translateParamVariables newValue:", newValue);
          if (doLog())
            console.log("[Report] translateParamVariables startPos:", startPos);
          if (doLog())
            console.log("[Report] translateParamVariables endPos:", endPos);
          if (doLog())
            console.log("[Report] translateParamVariables lastPos:", lastPos);
          newOption += option.substring(lastPos, startPos) + notNull(newValue);
          if (doLog())
            console.log(
              "[Report] translateParamVariables newOption:",
              newOption
            );
          // if (doLog())
          //   console.log("[Report] translateParamVariables check for next after endPos:" + endPos);
          lastPos = endPos + 1;
          startPos = option.indexOf("${", endPos);
          // if (doLog())
          //   console.log("[Report] translateParamVariables new startPos:" + startPos);
          // if (startPos !== -1)
          //   option.substring(endPos + 1, startPos);
          // else
          if (startPos === -1)
            newOption += option.substring(endPos + 1);
        } else {
          newOption = option.substring(endPos + 1);
          startPos = -1;
        }
      } else {
        startPos = -1;
      }
    }
    if (doLog())
      console.log(
        "[Report] translateParamVariables return newOption:",
        newOption
      );

    return newOption;
  };

  render() {
    if (doLog())
      console.log(
        "[Report]render reportDefinition:",
        this.props.reportDefinition
      );
    if (doLog()) console.log("[Report]render label:", this.props.label);
    //

    // const informationSection = (
    //   <p className={classes.Information}>{this.props.label}</p>
    // );

    let formSection = null;
    if (hasValue(this.state.fieldArray) && this.state.fieldArray.length > 0) {
      const count = this.state.fieldArray.length;
      formSection = [];
      for (let i = 0; i < count; i++) {
        formSection.push(
          <Grid item xs={12} key={this.state.fieldArray[i]}>
            {this.getFormField(this.state.fieldArray[i], false, true)}
          </Grid>
        );
      }
    }

    let pdfSection = null;
    if (this.state.searching || this.state.reportRunning) {
      pdfSection = <Spinner />;
    } else if (
      !this.props.loading &&
      (this.props.reportResult != null || this.props.reportError != null)
    ) {
      // if (doLog()) console.log("[render] build formattedResult");
      let formattedResult = "";
      pdfSection = null;
      if (this.props.reportError != null) {
        if (doLog())
          console.log("[render] reportError:" + this.props.reportError);
        formattedResult = "Error: " + this.props.reportError;
        pdfSection = <pre>{formattedResult}</pre>;
        if (doLog()) console.log("[render] report result is an error");
      } else {
        if (typeof this.props.reportResult === "string") {
          formattedResult = this.props.reportResult;
          if (doLog())
            console.log("[render] formattedResult string:" + formattedResult);
        } else {
          formattedResult = JSON.stringify(this.props.reportResult, null, 2);
          if (doLog())
            console.log("[render] formattedResult JSON:" + formattedResult);
        }
        if (formattedResult == null) {
          formattedResult = "";
          if (doLog())
            console.log("[render] formattedResult null:" + formattedResult);
        }
        if (formattedResult.startsWith("JVBERi0x")) {
          //BASE64 version of %PDF
          const blobUrl = "data:application/pdf;base64," + formattedResult;
          pdfSection = (
            <div>
              <object
                data={blobUrl}
                type="application/pdf"
                width="100%"
                height="1250px"
              >
                Report
              </object>
            </div>
          );
          if (doLog()) console.log("[render] result is a pdf");
        } else if (formattedResult.startsWith("File created:")) {
          const pdfFilePath = formattedResult.substring(22); // remove up to and including /webapps
          if (doLog()) console.log("[render] pdfFilePath:", pdfFilePath);
          const appPath = "";
          let filePath = "";
          const baseURL = this.props.baseURL;
          const pathname = ""; //this.props.pathname;
          if (doLog()) console.log("[render] pathname:", pathname);
          if (pathname.startsWith(appPath)) {
            filePath = baseURL + pathname + pdfFilePath;
          } else {
            filePath = baseURL + appPath + pathname + pdfFilePath;
          }
          if (doLog()) console.log("[render] filePath:", filePath);
          pdfSection = (
            <Grid container item>
              <Grid item xs={12}>
                <p>
                  <a
                    href={filePath}
                    // target="_blank"
                    // rel="noopener noreferrer"
                    download
                  >
                    Download the PDF shown below. (You may need use the back
                    arrow to get back to this screen.)
                  </a>
                </p>
              </Grid>
              <Grid item xs={12}>
                <iframe
                  src={filePath}
                  title={this.props.label}
                  width="100%"
                  height="1250px"
                ></iframe>
              </Grid>
            </Grid>
          );
        } else {
          pdfSection = <pre>{formattedResult}</pre>;
          if (doLog()) console.log("[render] result is a formattedResult");
        }
      }
      if (doLog()) console.log("[render] pdfSection:", pdfSection);
    }

    return (
      // <div className={classes.CrimeSubmission}>
      // <Grid container item className={classes.Card} spacing={gridSpacing}>
      <Grid container item spacing={gridSpacing}>
        {/* {informationSection}
        <Grid item xs={12}>
          <hr />
        </Grid> */}
        {formSection}
        <Grid item xs={12}>
          <Button
            variant="contained"
            //color="default"
            color="primary"
            size="small"
            disabled={this.checkRequiredField()}
            onClick={this.handleSubmitButton.bind(this)}
          >
            Run Report
          </Button>
        </Grid>
        {pdfSection}
      </Grid>
      // </div>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log("[Report] mapStateToProps state:", state);
  return {
    loading: state.trans.loading,
    error: state.trans.error,
    //
    userId: state.auth.userId,
    userName: state.auth.userName,
    //
    baseURL: state.trans.baseURL,
    pathname: state.trans.pathname,
    //
    result: state.trans.result,
    transDesc: state.trans.transDesc,
    //
    reportResult: state.trans.reportResult,
    reportError: state.trans.reportError,
    webAgencyList: state.trans.webAgencyList,
    modulePermissions: state.auth.modulePermissions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRunTransaction: (options, token, transDesc) =>
      dispatch(actions.runTransaction(options, token, transDesc)),
    onClearTransactionResult: () => dispatch(actions.clearTransactionResult()),
    onClearTransDesc: () => dispatch(actions.clearTransDesc()),
    onRunReport: (options, jsonResult, timeoutSecs, connectionName, token) =>
      dispatch(
        actions.runReport(
          options,
          jsonResult,
          timeoutSecs,
          connectionName,
          token
        )
      ),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(Report)
// );
export default connect(mapStateToProps, mapDispatchToProps)(Report);
